// Collection description toggle
function toggleDescription(button) {
  const wrapper = button.previousElementSibling;
  const isCollapsed = wrapper.classList.contains('collapsed');
  
  if (isCollapsed) {
    wrapper.classList.remove('collapsed');
    button.textContent = 'View less';
  } else {
    wrapper.classList.add('collapsed');
    button.textContent = 'View more';
  }
}
